import React from 'react';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../ui/Dialog';
import { Button } from '../../ui/Button';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

export function ExampleWorkOrderModal({ open, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} size="lg">
      <DialogHeader onClose={onClose}>Example Work Order</DialogHeader>
      <DialogBody>
        <div className="card bg-gray-50 p-6">
          {/* Simulated Work Order PDF */}
          <div className="bg-white rounded p-6 max-w-2xl mx-auto">
            {/* Header */}
            <div className="flex justify-between items-start border-b pb-4 mb-4">
              <div>
                <h3 className="text-lg font-bold text-gray-900">WORK ORDER</h3>
                <p className="text-sm text-gray-500">WO-2026-001</p>
              </div>
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">Acme Landscaping</p>
                <p className="text-xs text-gray-500">123 Main St, Austin, TX 78701</p>
                <p className="text-xs text-gray-500">(512) 555-0100</p>
              </div>
            </div>

            {/* Customer Info */}
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <p className="text-xs font-medium text-gray-500 uppercase">Customer</p>
                <p className="text-sm text-gray-900">John Smith</p>
                <p className="text-xs text-gray-500">456 Oak Ave, Austin, TX 78702</p>
              </div>
              <div>
                <p className="text-xs font-medium text-gray-500 uppercase">Scheduled</p>
                <p className="text-sm text-gray-900">Mon, Jan 15, 2026</p>
                <p className="text-xs text-gray-500">8:00 AM – 12:00 PM</p>
              </div>
            </div>

            {/* Line Items */}
            <table className="w-full text-sm mb-4">
              <thead>
                <tr className="border-b border-[color:var(--color-border)]">
                  <th className="text-left py-2 text-xs font-medium text-gray-500">Item</th>
                  <th className="text-right py-2 text-xs font-medium text-gray-500">Qty</th>
                  <th className="text-right py-2 text-xs font-medium text-gray-500">Unit</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                <tr>
                  <td className="py-2 text-gray-900">Lawn Mowing — Front & Back</td>
                  <td className="py-2 text-right text-gray-600">1</td>
                  <td className="py-2 text-right text-gray-600">ea</td>
                </tr>
                <tr>
                  <td className="py-2 text-gray-900">Hedge Trimming</td>
                  <td className="py-2 text-right text-gray-600">120</td>
                  <td className="py-2 text-right text-gray-600">lf</td>
                </tr>
                <tr>
                  <td className="py-2 text-gray-900">Mulch Application</td>
                  <td className="py-2 text-right text-gray-600">3</td>
                  <td className="py-2 text-right text-gray-600">cu yd</td>
                </tr>
              </tbody>
            </table>

            {/* Crew Assignment */}
            <div className="border-t pt-3">
              <p className="text-xs font-medium text-gray-500 uppercase mb-1">Assigned Crew</p>
              <p className="text-sm text-gray-900">Crew Alpha — Mike (Foreman), Jake, Luis</p>
            </div>

            {/* Notes */}
            <div className="border-t pt-3 mt-3">
              <p className="text-xs font-medium text-gray-500 uppercase mb-1">Notes</p>
              <p className="text-sm text-gray-600">
                Gate code: 1234. Dog in backyard — please ring doorbell before entering.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-4 flex items-start gap-3 bg-red-50 p-3" style={{ borderRadius: 'var(--radius-md)' }}>
          <DocumentTextIcon className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" />
          <div className="text-sm text-red-800">
            <p className="font-medium">This is what your field techs will see</p>
            <p className="mt-1">
              Work orders are generated from accepted quotes. Each work order shows the assigned crew,
              scheduled time, line items, and any special notes. Field techs can clock in/out and
              mark items complete from their mobile device.
            </p>
          </div>
        </div>
      </DialogBody>
      <DialogFooter>
        <Button onClick={onClose}>Got It</Button>
      </DialogFooter>
    </Dialog>
  );
}
